import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-event20250415',
  templateUrl: './event20250415.component.html',
  styleUrls: ['./event20250415.component.css']
})
export class Event20250415Component implements OnInit {

  constructor(
    private authService: AuthService,
    private commonService: CommonService,
    private router: Router
  ) {
    if(this.commonService.getIsMobile()) {
      this.router.navigate(['/m/event'])
    }
  }
  user: User
  ngOnInit(): void {
    this.user = this.commonService.getUserInfo()
  }
  moveJoin() {
    window.scrollTo(0, 0);
    this.router.navigate(['/join'])
  }


  logout(){
    this.authService.logout()
  }

  openGuideWindow() {
    var width = 1400 //screen.availWidth - 150
    var height = 800 //screen.availHeight - 250
    var windowPopup = window.open('/guide', 'guideWindow', 'width='+width/13*11+',height='+height+',left='+width/13*4+',top=0,scrollbars=no');
    windowPopup.focus();
  }
}
